// extracted by mini-css-extract-plugin
module.exports = {"cardOptionButton":"CardOptionButton_cardOptionButton__2JzPt","icon":"CardOptionButton_icon__2hX-3"};